<template v-slot:activator="{ on }">
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Analises de leite</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            v-if="!isConfirmado()"
            color="secondary"
            class="button-ciencia"
            @click="confirmaAnalise"
          >
            Estou Ciente
          </v-btn>
          <v-btn
            v-else
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <div
        id="invoice"
        ref="content"
      >
        <div style="display: flex; align-items: center;">
          <v-col
            cols="12"
            lg="5"
          >
            <v-select
              v-model="selectedTanque"
              :items="analises.tanqueleite"
              item-text="nome"
              item-value="id"
              return-object
              :disabled="disabledSelectTanque"
              :label="labelSelect"
              @change="onChange($event)"
            />
          </v-col>
        </div>
        <v-simple-table v-if="tabelaVisivel">
          <thead>
            <tr id="analise">
              <th class="primary--text format-text">
                Análise
              </th>
              <th class="primary--text text-center format-text">
                Resultado
              </th>
              <th class="primary--text text-center format-text">
                Padrão
              </th>
              <!-- <th class="primary--text text-center format-text">
                Tanque de leite
              </th> -->
            </tr>
          </thead>
          <tbody v-if="listarAnalises">
            <tr
              v-for="(item, index) in listaAnalise"
              :key="index"
            >
              <td class="text-left">
                <span v-if="item.criterio">{{ item.criterio.nome }}</span>
              </td>
              <td
                class="text-center"
                :style="{ color: getColor(item.resultado, item.criterio) }"
              >
                {{ item.resultado }}
              </td>

              <td class="text-center">
                {{ item.criterio.valorpadrao > 0 ? getMinMax(item.criterio.forapadrao) + item.criterio.valorpadrao + '' : '' }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-dialog>
</template>

<script>
  import analisesservice from '../../../services/analisesservice'
  import utils from '../../../services/utils'
  import moment from 'moment'

  export default {
    name: 'DashboardFormsItensReciboForm',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],
    props: {
      analises: {
        type: Object,
        default: function () {
          return {
            listaAnalise: [],
            analiseProdutor: [],
            tanqueleite: {
              select: null,
              items: [],
            },
          }
        },
      },
      exibedialog: {
        type: Boolean,
        default: false,
      },
      empresadaanalise: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },

    data: () => ({
      exibedialogInterno: false,
      disabledSelectTanque: false,
      tabelaVisivel: false,
      selectedTanque: null,
      labelSelect: 'Selecione um tanque de leite',
      listarAnalises: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),
    watch: {
      exibedialog: function (val) {
        this.exibedialogInterno = val
        this.carregaTanques(this.selectedTanque)
      },
    },
    mounted () {
      this.carregaTanques()
    },
    methods: {
      onChange (event) {
        this.carregaTanques(this.selectedTanque)
      },
      fechaDialog () {
        this.exibedialogInterno = false
        this.tabelaVisivel = false
        this.analises.tanqueleite.select = null
        this.selectedTanque = null
        this.listarAnalises = false
        this.disabledSelectTanque = false
        this.listaAnalise = []
        this.labelSelect = 'Selecione um tanque de leite'
        this.$emit('update-dialog', this.exibedialogInterno)
      },
      formatDateTime (date) {
        if (date) {
          date = moment.utc(date).local().format('DD/MM/YYYY')
          return date
        }
      },
      clearSelection () {
        this.labelSelect = 'Selecione um tanque de leite'
        this.selectedTanque = null
        this.carregaTanques(this.selectedTanque)
      },
      carregaTanques (selectedTanque) {
        if (this.exibedialogInterno === true) {
          if (this.analises.tanqueleite.length === 1) {
            this.labelSelect = this.analises.tanqueleite[0].nome
            this.selectedTanque = this.analises.tanqueleite[0]
            this.disabledSelectTanque = true
            this.listarAnalises = true
            this.listaAnalise = this.analises.listaAnalise
            this.analiseProdutor = this.analises.analiseprodutor
            this.tabelaVisivel = true
          }
          if (selectedTanque) {
            this.listaAnalise = this.analises.listaAnalise.filter(obj => obj.idTanqueleite === selectedTanque.id)
            this.tabelaVisivel = true
            this.listarAnalises = true
          }

          this.analises.tanqueleite.select = selectedTanque || this.selectedTanque
        }
      },
      getColor (resultado, criterio) {
        const valorResultado = parseFloat(resultado.replace(',', '.'))
        const corPadrao = 'dark'
        let cor = corPadrao

        if (criterio.forapadrao === 0 && valorResultado >= criterio.valorpadrao) {
          cor = 'red'
        } else if (criterio.forapadrao === 1 && valorResultado < criterio.valorpadrao) {
          cor = 'red'
        }

        return cor
      },
      exibeIcone (resultado, criterio) {
        const valorResultado = parseFloat(resultado.replace(',', '.'))
        let icone = false

        if (criterio.forapadrao === 0 && valorResultado >= criterio.valorpadrao) {
          icone = true
        } else if (criterio.forapadrao === 1 && valorResultado < criterio.valorpadrao) {
          icone = true
        }

        return icone
      },

      getMinMax (valor) {
        if (valor === 0) {
          return '< '
        } else if (valor === 1) {
          return '>= '
        } else {
          return ''
        }
      },
      async confirmaAnalise () {
        var analise = this.analises.listaAnalise[0].analise
        var idProdutor = this.analises.listaAnalise[0].idProdutor

        if (this.analises.tanqueleite.select !== null) {
          await analisesservice.confirmaResultadoAnalise(analise.id, this.analises.tanqueleite.select.id, idProdutor, analise.contratoId, analise.nomeBD).then(resposta => {
            if (resposta.data.success_request) {
              this.showSnackbar('success', 3000, resposta.data.mensagem)
              this.fechaDialog()
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
              this.fechaDialog()
            } else {
              this.showSnackbar('error', 3000, e.message)
              this.fechaDialog()
            }
          })
        }
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      isConfirmado () {
        if (this.analises.tanqueleite !== undefined && this.analises.tanqueleite.length > 1) {
          if (this.analises.tanqueleite.select !== null) {
            var confirmado = false
            this.analises.analiseProdutor.forEach(item => {
              if (item.tanqueleiteId === this.analises.tanqueleite.select.id && confirmado !== item.confirmaResultado) {
                confirmado = item.confirmaResultado
              }
            })
            return confirmado
          }
        } else {
          if (this.analises.analiseProdutor !== undefined && this.analises.analiseProdutor.length > 0) {
            if (this.analises.analiseProdutor[0].confirmaResultado) {
              return true
            } else {
              return false
            }
          }
        }
      },
    },
  }
</script>

<style scoped>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
.format-text {
  font-size: 12px !important;
}
#btn_confirmar {
  padding-left: 2px;
}
#analise {
  font-weight: bold;
}
.custom-color {
  color: rgb(218, 22, 22);
  text-transform: none;
  height: 5px !important;
  width: 5px !important;
  border-radius: 5px !important;
  margin-top: 13px !important;
  padding: 16px 50px !important;
}
.button-ciencia {
  text-transform: none;
  margin-top: 13px !important;
  height: 5px !important;
  width: 15px !important;
}
.v-sheet .v-toolbar__content .v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab), .v-sheet .v-toolbar__content .v-btn.v-size--large:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 15px 18px !important;
  border-radius: 10px !important;
}
.custom-button:hover {
  background-color: #d6d1d1 !important;
}

</style>
